import { api } from '@goaltree/backend/convex/_generated/api'
import { useMutation, useQuery } from 'convex/react'
import { useTranslation } from 'react-i18next'

export function CoachChangeStrip() {
  const { t } = useTranslation()
  const rows = useQuery(api.coachChanges.list)
  const undo = useMutation(api.coachChanges.undo)
  const row = rows?.find((r) => r.canUndo && !r.viaConnector)
  if (!row) return null
  return (
    <div className="flex items-center gap-2 border-b border-border/40 bg-muted/30 px-3.5 py-1.5 text-[11px]">
      <span className="min-w-0 flex-1 truncate text-muted-foreground">{row.summary}</span>
      <button
        type="button"
        className="shrink-0 cursor-pointer font-semibold text-primary-text hover:underline"
        onClick={() => void undo({ id: row.id })}
      >
        {t('coachChanges.undo')}
      </button>
    </div>
  )
}

export function CoachChangeLog({ name }: { name: string }) {
  const { t } = useTranslation()
  const rows = useQuery(api.coachChanges.list)
  const undo = useMutation(api.coachChanges.undo)
  return (
    <div className="px-4 py-3.5">
      <p className="text-sm font-medium">{t('coachChanges.label', { name })}</p>
      {!rows?.length ? (
        <p className="mt-0.5 text-xs text-muted-foreground">{t('coachChanges.empty')}</p>
      ) : (
        <ul className="mt-2 flex flex-col gap-1.5">
          {rows.map((row) => (
            <li key={row.id} className="flex items-center gap-2 text-xs">
              <span className="min-w-0 flex-1 truncate text-muted-foreground">
                {row.viaConnector && (
                  <span className="mr-1.5 font-medium text-foreground/70">
                    {t('coachChanges.viaConnector')}
                  </span>
                )}
                {row.summary}
              </span>
              {row.canUndo ? (
                <button
                  type="button"
                  className="shrink-0 cursor-pointer font-semibold text-primary-text hover:underline"
                  onClick={() => void undo({ id: row.id })}
                >
                  {t('coachChanges.undo')}
                </button>
              ) : row.undone ? (
                <span className="shrink-0 text-muted-foreground/70">
                  {t('coachChanges.undone')}
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
